<template>
<div>
  <el-table-wrapper ref="eventTable" :data="tableDatas" :columns="targetColumn" :show-custom-header="true" :show-search-tool="showSearchTool" :show-overflow-tooltip="true" :pagination="true"
    :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable" @selection-change="onSelectionChange">
    <template slot-scope="scope" slot="eventlevel-slot">
      <w-eventlevel-cell v-if="scope.row.eventlevelId != null" :eventlevel-id="scope.row.eventlevelId"/>
      <span v-else>-</span>
    </template>
    <template slot-scope="scope" slot="relation-event">
        <span v-if="scope.row.histChainKey" @click="relationEventClick(scope.row)"><i class="far fa-search-plus c-pointer"></i></span>
      </template>
  </el-table-wrapper>
  <w-vcenter-log-event-popup ref="vcenterLogEventPopup" />
</div>
</template>

<script>
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { columnDefault } from '@/constants/table';
import { mapGetters } from 'vuex';
import { isNil, isEmpty, isEqual, cloneDeep } from 'lodash';
import { getDateToString } from '@/utils/date';
import logApi from '@/api/virtual/performance/log';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WVcenterLogEventPopup from '@/views/performance/components/virtual/VcenterLogEventPopup';

export default {
  name: 'WEventLogTable',
  components: {
    WEventlevelCell,
    WVcenterLogEventPopup,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
    timeParam: {
      type: Object,
    },
    showSearchTool: {
      type: Boolean,
    },
    checkedRows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableDatas: [],
      columnDefault,
      tableTotal: 0,
      columns: [
        {
          type: 'selection',
          width: '40px',
        },
        {
          label: '상태',
          prop: 'isChecked',
          width: '100px',
          formatter: this.getStatusFormatter,
        },
        {
          label: '등급',
          prop: 'eventlevelName',
          width: '100px',
          scopedSlot: 'eventlevel-slot',
          columnKey: 'eventlevelId',
          searchable: true,
          searchType: 'eventlevel',
          remoteProp: 'eventlevelId',
        },
        {
          label: '필터명',
          prop: 'filterName',
          width: '100px',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          label: '설명',
          prop: 'message',
          remoteProp: 'message',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          label: '대상',
          prop: 'objName',
          width: '300px',
          remoteProp: 'objName',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          label: '날짜 시간',
          prop: 'timestamp',
          width: '150px',
          remoteProp: 'timestamp',
          formatter: this.getDateFormatter,
        },
      ],
      EMPTY_TEXT,
      targetColumn: [],
    };
  },
  computed: mapGetters(['selectedObjDefineIds', 'selectedNode']),
  watch: {
    active: {
      handler() {
        this.targetColumn = cloneDeep(this.columns);
        if (this.selectedNode.hypervisorType !== 'RHEV') {
          this.targetColumn.push({ label: '관련 이벤트', width: '100px', scopedSlot: 'relation-event' });
        }
        this.loadStore();
      },
    },
    selectedNode: {
      handler() {
        this.targetColumn = cloneDeep(this.columns);
        if (this.selectedNode.hypervisorType !== 'RHEV') {
          this.targetColumn.push({ label: '관련 이벤트', width: '100px', scopedSlot: 'relation-event' });
        }
        if (this.$refs.eventTable === undefined) {
          this.$nextTick(() => {
            this.loadStore();
          });
        } else {
          this.loadStore();
        }
      },
    },
  },
  methods: {
    loadStore() {
      if (this.active && !isEmpty(this.timeParam)) {
        const tableParams = this.$refs.eventTable.getParameter();
        const params = {
          objId: this.selectedNode.obj ? this.selectedNode.obj.objId : null,
          virtualcenterGroupId: this.selectedNode.virtualcenterGroupId,
          objtypeId: this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId,
          startDateTime: this.timeParam.startDatetime,
          endDateTime: this.timeParam.endDatetime,
          logType: 'EVENT',
          queryList: tableParams.searchParams,
          start: tableParams.start,
          limit: tableParams.limit,
        };
        logApi.getVcenterLogByHistType(params).then((response) => {
          if (response.data.success) {
            this.tableDatas = response.data.data;
            this.tableTotal = response.data.total;
          }
        });
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onChangeTable() {
      this.loadStore();
    },
    onSelectionChange(selection) {
      this.$emit('selection-change', selection);
    },
    convertValue(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null);
    },
    getStatusFormatter(row, column, value) {
      let returnValue = getValueAfterCheckEmpty(value);
      if (!isNil(value)) {
        if (isEqual(value, '1')) {
          returnValue = '확인';
        } else {
          returnValue = '미확인';
        }
      }
      return returnValue;
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value) && value !== '') {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    relationEventClick(currentRow) {
      const params = {
        histChainKey: currentRow.histChainKey,
        startDateTime: this.timeParam.startDatetime,
        endDateTime: this.timeParam.endDatetime,
        objtypeId: this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId,
        logType: 'EVENT',
      };
      this.$refs.vcenterLogEventPopup.open(params);
    },
    convertValuByUnit,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/virtual/performance/group/components/EventLogTable.vue